var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container box"},[_c('b-message',{attrs:{"title":"Unauthorized","type":"is-danger","has-icon":"","closable":false}},[_vm._v(" You are not authorized to view this page. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }